import ManagersService from './ManagersService';

let instance;

export default function ManagersServiceProvider() {
  if (!instance) {
    instance = new ManagersService();
  }

  return instance;
}



// WEBPACK FOOTER //
// ./src/api/managers/ManagersServiceProvider.js